import { Snippet } from '../../dataModels';

export const monitoringSnippet: Snippet = {
  shiftsummaryDisplyId: '13601885-bbf3-ec11-9147-005056b29cce',
  displayTemplateId: 'f5b575b7-fa31-439f-aea3-dd241b3d4d73',
  name: 'Monitoring',
  displayName: 'Monitoring',
  description: null,
  order: 9,
  count: 0,
  groupSnippets: null,
  maxRows: 0,
  type: 'Monitoring',
  enableEdit: 'False',
  enableComment: false,
  isEdited: false,
  canAddDeleteRows: false,
  configuration: {
    rowTitleKey: 'TargetName',
    columnCount: 22,
    columns: [
      {
        id: 1,
        name: 'TargetName',
        displayName: 'Target Name',
        controlType: 'Text - Single Line',
        controlValues: null,
        visible: 'True',
      },
      {
        id: 2,
        name: 'TargetGroup',
        displayName: 'Target Group',
        controlType: 'Text - Single Line',
        controlValues: null,
        visible: 'True',
      },
      {
        id: 3,
        name: 'TargetDescription',
        displayName: 'Target Description',
        controlType: 'Text - Single Line',
        controlValues: null,
        visible: 'True',
      },
      {
        id: 4,
        name: 'UOM',
        displayName: 'Unit Of Measure',
        controlType: 'Text - Single Line',
        controlValues: null,
        visible: 'True',
      },
      {
        id: 5,
        name: 'MeasurementTag',
        displayName: 'Measurement Tag',
        controlType: 'Text - Single Line',
        controlValues: null,
        visible: 'True',
      },
      {
        id: 6,
        name: 'TagDescription',
        displayName: 'Tag Description',
        controlType: 'Text - Single Line',
        controlValues: null,
        visible: 'True',
      },
      {
        id: 7,
        name: 'Variable',
        displayName: 'Variable',
        controlType: 'Text - Single Line',
        controlValues: null,
        visible: 'True',
      },
      {
        id: 8,
        name: 'LimitName',
        displayName: 'Limit Name',
        controlType: 'Text - Single Line',
        controlValues: null,
        visible: 'True',
      },
      {
        id: 9,
        name: 'AssetDisplayName',
        displayName: 'Asset',
        controlType: 'Text - Single Line',
        controlValues: null,
        visible: 'True',
      },
      {
        id: 10,
        name: 'StartTime',
        displayName: 'Start Time',
        controlType: 'Text - Single Line',
        controlValues: null,
        visible: 'True',
      },
      {
        id: 11,
        name: 'EndTime',
        displayName: 'End Time',
        controlType: 'Text - Single Line',
        controlValues: null,
        visible: 'True',
      },
      {
        id: 12,
        name: 'Duration',
        displayName: 'Duration',
        controlType: 'Text - Single Line',
        controlValues: null,
        visible: 'True',
      },
      {
        id: 13,
        name: 'Status',
        displayName: 'Deviation Status',
        controlType: 'Text - Single Line',
        controlValues: null,
        visible: 'True',
      },
      {
        id: 14,
        name: 'LimitValue',
        displayName: 'Limit',
        controlType: 'Text - Single Line',
        controlValues: null,
        visible: 'True',
      },
      {
        id: 15,
        name: 'Actual',
        displayName: 'Deviating Value',
        controlType: 'Text - Single Line',
        controlValues: null,
        visible: 'True',
      },
      {
        id: 16,
        name: 'DeviationQuantity',
        displayName: 'Deviation Quantity',
        controlType: 'Text - Single Line',
        controlValues: null,
        visible: 'True',
      },
      {
        id: 17,
        name: 'Impact',
        displayName: 'Impact',
        controlType: 'Text - Single Line',
        controlValues: null,
        visible: 'True',
      },
      {
        id: 18,
        name: 'ImpactUnit',
        displayName: 'Impact UOM',
        controlType: 'Text - Single Line',
        controlValues: null,
        visible: 'True',
      },
      {
        id: 19,
        name: 'MissingRemark',
        displayName: 'Missing Remark',
        controlType: 'Text - Single Line',
        controlValues: null,
        visible: 'True',
      },
      {
        id: 20,
        name: 'UpdatedBy',
        displayName: 'Updated By',
        controlType: 'Text - Single Line',
        controlValues: null,
        visible: 'True',
      },
      {
        id: 21,
        name: 'Reasons',
        displayName: 'Reason',
        controlType: 'Text - Single Line',
        controlValues: null,
        visible: 'True',
      },
      {
        id: 22,
        name: 'Notes',
        displayName: 'Comment',
        controlType: 'Text - Single Line',
        controlValues: null,
        visible: 'True',
      },
    ],
    matrixCells: null,
  },
  data: [
    {
      rollupDetails: null,
      rowCount: 0,
      rowData: Array.from(Array(3).keys()).map((i) => ({
        TargetName: 'TargetName ' + i,
        TargetGroup: 'TargetGroup ' + i,
        TargetDescription: 'TargetDescription ' + i,
        UOM: 'UOM ' + i,
        MeasurementTag: 'MeasurementTag ' + i,
        TagDescription: 'TagDescription ' + i,
        Variable: 'Variable ' + i,
        LimitName: 'LimitName ' + i,
        AssetDispla: 'AssetDispla ' + i,
        StartTime: 'StartTime ' + i,
        EndTime: 'EndTime ' + i,
        Duration: 'Duration ' + i,
        Status: 'Status ' + i,
        LimitValue: 'LimitValue ' + i,
        Actual: 'Actual ' + i,
        DeviationQuantity: 'DeviationQuantity ' + i,
        Impact: 'Impact ' + i,
        ImpactUnit: 'ImpactUnit ' + i,
        MissingRemark: 'MissingRemark ' + i,
        UpdatedBy: 'UpdatedBy ' + i,
        Reasons: 'Reasons ' + i,
        Notes: 'Notes ' + i,
      })),
    },
  ],
};
